import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import leftIcon from "assets/left-icon-blue.svg";
import rightIcon from "assets/right-icon-blue.svg";
import { useEffect, useState } from "react";
const PaginationImport = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handleClick = (pageNumber) => {
    if (pageNumber < 1) return;
    paginate(pageNumber, itemsPerPage);
  };
  const handleResize = (itemsPerPage) => {
    if (itemsPerPage < 1) return;
    paginate(currentPage + 1, itemsPerPage);
  };
  function formatNumber(num) {
    return String(num).padStart(2, '0');
  }
  useEffect(() => {
    if (currentPage != 0 || itemsPerPage > 7) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
        const scroller = document.getElementsByClassName('MuiDataGrid-virtualScroller')[0]
        console.log(scroller)
        if (scroller) {
          scroller.scrollTop = document.body.scrollHeight + 1000 // Scroll to the bottom
        }
      }, 10)
    }

  }, [itemsPerPage])



  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", sm: "column", md: "row" },
        paddingTop: "10px",
        background: "#F5F5F7",
        padding: "10px 30px",
        alignItems: "center"
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "30px",
            color: "grey",
          }}
        >
          RECORDS PER PAGE
        </Typography>
        <Box sx={{ display: "flex", paddingLeft: "10px" }}>
          <RemoveIcon
            onClick={() => {
              handleResize(itemsPerPage - 1);
            }}
            style={{
              backgroundColor: "#0258ab",
              color: "white",
              cursor: "pointer",
            }}
          />
          <Typography sx={{ paddingLeft: "5px", color: "#3B454F", fontSize: "15.72px", textDecoration: "underline" }}>{formatNumber(Number(itemsPerPage))}</Typography>
          {currentPage + 1 !== pageNumbers.length && <AddIcon
            onClick={() => {
              handleResize(itemsPerPage + 1);
            }}
            style={{
              backgroundColor: "#0258ab",
              color: "white",
              marginLeft: "5px",
              cursor: "pointer",
            }}
          />}
        </Box>
      </Box>
      <Box sx={{ display: "flex" }}>
        <img
          src={leftIcon}
          alt="Left Icon"
          onClick={() => {
            handleClick(currentPage);
          }}
          style={{
            paddingBottom: "5px",
            paddingRight: "5px",
            cursor: "pointer",
          }}
        />
        <Typography sx={{
          fontFamily: "Montserrat",
          fontSize: "14.29px",
          fontWeight: 500,
          lineHeight: "30px",
          color: "grey",
          paddingBottom: "5px",
        }}>PAGE</Typography>
        <Typography sx={{
          paddingLeft: "5px",
          paddingTop: "4px",
          textDecoration: "underline",
          fontSize: "14.29px",
          color: "#0E2B63"
        }}> {formatNumber(Number(currentPage + 1))}</Typography>
        <Typography sx={{
          paddingLeft: "5px",
          paddingBottom: "5px",
          fontFamily: "Montserrat",
          fontSize: "14.29px",
          fontWeight: 500,
          lineHeight: "30px",
          color: "grey",
        }}> OF</Typography>
        <Typography sx={{
          paddingLeft: "5px",
          paddingTop: "4px",
          fontSize: "14.29px",
          textDecoration: "underline",
          color: "#0E2B63"
        }}>
          {" "}
          {formatNumber(Number(pageNumbers.length))}
        </Typography>

        {currentPage + 1 === pageNumbers.length}
        {currentPage + 1 !== pageNumbers.length && (
          <img
            src={rightIcon}
            alt="Right Icon"
            onClick={() => {
              handleClick(currentPage + 2);
            }}
            style={{
              paddingBottom: "5px",
              paddingLeft: "5px",
              cursor: "pointer",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default PaginationImport;
